module.exports = __webpack_public_path__ + "img/element_type_benefit.fe02a352.png";